console.log('init: bootstrap-js'); // eslint-disable-line no-console

const jQuery = require('vendor/jquery-js');
require('bootstrap/dist/js/bootstrap');

module.exports = jQuery;
